import { render } from "./YouTube.vue?vue&type=template&id=2858c9d4"
import script from "./YouTube.vue?vue&type=script&lang=js"
export * from "./YouTube.vue?vue&type=script&lang=js"

import "./YouTube.vue?vue&type=style&index=0&id=2858c9d4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__